import {
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  SettingOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import React, { useState } from "react";
import Report from "./reports";
import "./style/project.scss";
import dayjs from "dayjs";

const { Sider, Content } = Layout;

export const Users = ({ setAuth }) => {
  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, "year").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const props = { startDate, endDate, setEndDate, setStartDate };

  const handleLogout = (event) => {
    if (event.key === "4") {
      localStorage.removeItem("token");
      setAuth(false);
    }
  };
  return (
    <>
      <div className="header">
        <h1>StockBot (Buy)</h1>
      </div>
      <Layout
        style={{ height: "100vh", marginTop: "63px", background: "white" }}
      >
        <Sider trigger={null} collapsible>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            onClick={handleLogout}
            items={[
              {
                key: "1",
                icon: <UserOutlined />,
                label: "Users",
              },

              {
                key: "2",
                icon: <UploadOutlined />,
                label: "Stratergy",
              },
              {
                key: "3",
                icon: <SettingOutlined />,
                label: "Orders",
              },
              {
                key: "5",
                icon: <VideoCameraOutlined />,
                label: "Live Pl",
                disabled: true,
              },
              {
                key: "4",
                icon: <LogoutOutlined />,
                label: "Logout",
                style: { background: "lightred" },
              },
            ]}
          />
        </Sider>
        <Layout className="site-layout">
          <Content>
            <Report setAuth={setAuth} {...props} />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export default Users;
